import signInPage from '@containers/App/user/auth/sign-in';
import { getServerSideProps } from '@helpers/getServerSideProps/getSSProps';
export default signInPage;
export { getServerSideProps };
